module.exports = __webpack_public_path__ + "static/example_month_columns-5d95a5332c9c2169fb7de4922a1a7dd2.png";